import React, { createContext, useEffect, useState } from 'react';
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import AppRouter from './router'
import firebaseConfig from "./firebaseConfig.json";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/icons-ui.css";
import "./assets/css/theme.css";


const AppContext = createContext()

export default function App(){
  const [user, setUser] = useState();
  useEffect(()=>{
    initializeApp(firebaseConfig);
    const auth = getAuth();

    let unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user||{});
    })
    return unsubscribe
  },[])

  return  <AppContext.Provider value={{user: user, init: !!user}}>
            <div className="ball b1" />
            <div className="ball b2" />
            <div className="ball b3" />
            <div className="ball b4" />
            <AppRouter />
          </AppContext.Provider>;
}
